import React from "react";
import { Box } from "@mui/material";

const CustomHamburgerIcon = () => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      gap: 0.5,
    }}>
    <Box sx={{ width: 22, height: 2, bgcolor: "black", borderRadius: 1 }} />
    <Box sx={{ width: 16, height: 2, bgcolor: "black", borderRadius: 1 }} />
    <Box sx={{ width: 20, height: 2, bgcolor: "black", borderRadius: 1 }} />
  </Box>
);

export default CustomHamburgerIcon;
